module.exports = __webpack_public_path__ + "static/greedIsGood-2ad17ec36f5a0f396e29dbb1f30f5693.jpg";